import React, { useRef, useState, useLayoutEffect } from 'react';

// Shrinks its content to fit the available width so large values never spill onto
// the neighbouring cell. The text renders at its natural (CSS) size and is scaled
// down only when it would overflow — so small values keep the full font size and
// big ones step down smoothly. align controls which edge stays anchored.
const FitText = ({ children, align = 'left', min = 0.4, className = '' }) => {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) return;

    const measure = () => {
      const avail = outer.clientWidth;
      const natural = inner.scrollWidth; // layout width, unaffected by transform
      if (avail > 0 && natural > 0) {
        const next = Math.min(1, Math.max(min, avail / natural));
        setScale((prev) => (Math.abs(prev - next) > 0.005 ? next : prev));
      }
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(outer);
    ro.observe(inner);
    return () => ro.disconnect();
  }, [min]);

  return (
    <div
      ref={outerRef}
      className={`w-full overflow-hidden flex ${align === 'right' ? 'justify-end' : 'justify-start'} ${className}`}
    >
      <div
        ref={innerRef}
        className="w-max max-w-none shrink-0 whitespace-nowrap"
        style={{ transform: `scale(${scale})`, transformOrigin: `${align} center` }}
      >
        {children}
      </div>
    </div>
  );
};

export default FitText;
